<template>
  <v-stepper
    v-model="proxyModel"
    v-bind="$attrs"
    v-on="forwardedListeners"
  >
    <v-stepper-header>
      <template v-for="(step, i) in steps">
        <v-stepper-step
          :key="`step-${i}`"
          :complete="proxyModel > i + 1"
          :step="i + 1"
          :editable="isEditable(i + 1)"
          :class="{ 'step-editable': isEditable(i + 1) }"
          @click="$emit('navigate', i + 1)"
        >
          {{ step.title }}
        </v-stepper-step>

        <v-divider
          v-if="i < steps.length - 1"
          :key="`divider-${i}`"
        />
      </template>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content
        v-for="(step, i) in steps"
        :key="`content-${i}`"
        :step="i + 1"
      >
        <slot :name="`step-${i + 1}`" />
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
// Stepper driven by a `steps` array ([{ title }]); each step's body comes in
// through a #step-N slot. `complete` is derived from the model; editability is
// delegated to the `canNavigate` callback, and a click emits `navigate`.
// Vuetify 3 cutover: v-stepper-items/-content -> v-stepper-window/-window-item
// and v-stepper-step -> v-stepper-item, all contained to this file.
export default {
  name: "EkitabuStepper",
  inheritAttrs: false,
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Number, String],
      default: 1,
    },
    canNavigate: {
      type: Function,
      default: null,
    },
  },
  computed: {
    proxyModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    // Forward any other listeners to v-stepper, but not `input` — that channel
    // is owned by proxyModel, so forwarding it too would double-fire the model.
    forwardedListeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...rest } = this.$listeners;
      return rest;
    },
  },
  methods: {
    isEditable(stepNumber) {
      return this.canNavigate ? this.canNavigate(stepNumber) : false;
    },
  },
};
</script>
